import { ResourceListCard } from "#web/components/common/ResourceListCard/ResourceListCard";
import { Box, DataTable, Icon, InlineStack, Page, Text } from "@shopify/polaris";
import { CheckIcon, XIcon } from "@shopify/polaris-icons";
import { useNavigate } from "react-router-dom";

import { brandLockLogo, keepcartLogo, promoPiratesLogo, veeperLogo } from "../assets";

interface ComparisonFeature {
  brandlock: boolean;
  keepcart: boolean;
  name: string;
  promoPirates: boolean;
  veeper: boolean;
}

const features: ComparisonFeature[] = [
  {
    brandlock: true,
    keepcart: true,
    name: "Offers extension blocking",
    promoPirates: true,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Works with Headless",
    promoPirates: false,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Works with Checkout Extensibility",
    promoPirates: false,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Blocks across Safari & iOS",
    promoPirates: false,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Blocks 40+ extensions",
    promoPirates: false,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Exclude codes from Blocking",
    promoPirates: false,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Multiple site leak scans / day",
    promoPirates: false,
    veeper: false,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Duplicate Blocking",
    promoPirates: false,
    veeper: false,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Coupon leak usage tracking",
    promoPirates: false,
    veeper: false,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "High-Risk leak tagging",
    promoPirates: false,
    veeper: false,
  },
  {
    brandlock: false,
    keepcart: true,
    name: "Code for extension users",
    promoPirates: false,
    veeper: false,
  },
  {
    brandlock: false,
    keepcart: false,
    name: "Block all codes during time period",
    promoPirates: false,
    veeper: true,
  },
  {
    brandlock: false,
    keepcart: false,
    name: "Remove leaked codes from sites",
    promoPirates: false,
    veeper: false,
  },
];

export const AppComparison = () => {
  const navigate = useNavigate();

  const rows = features.map((feature) => [
    <Box paddingBlock="150">
      <Text as="span" variant="bodyLg">
        {feature.name}
      </Text>
    </Box>,
    <Box paddingBlock="150">
      <InlineStack align="center">
        <Icon source={feature.keepcart ? CheckIcon : XIcon} tone={feature.keepcart ? "success" : "critical"} />
      </InlineStack>
    </Box>,
    <Box paddingBlock="150">
      <InlineStack align="center">
        <Icon source={feature.veeper ? CheckIcon : XIcon} tone={feature.veeper ? "success" : "critical"} />
      </InlineStack>
    </Box>,
    <Box paddingBlock="150">
      <InlineStack align="center">
        <Icon source={feature.brandlock ? CheckIcon : XIcon} tone={feature.brandlock ? "success" : "critical"} />
      </InlineStack>
    </Box>,
    <Box paddingBlock="150">
      <InlineStack align="center">
        <Icon source={feature.promoPirates ? CheckIcon : XIcon} tone={feature.promoPirates ? "success" : "critical"} />
      </InlineStack>
    </Box>,
  ]);

  return (
    <Page
      backAction={{
        content: "Back",
        onAction: () => {
          navigate("/");
        },
      }}
      title="Us vs other coupon protection apps"
    >
      <ResourceListCard>
        <DataTable
          columnContentTypes={["text", "text", "text", "text", "text"]}
          hasZebraStripingOnData
          headings={[
            "",
            <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
              <img alt="KeepCart" height={40} src={keepcartLogo} style={{ objectFit: "contain" }} width={100} />
            </div>,
            <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
              <img alt="Veeper" height={35} src={veeperLogo} style={{ objectFit: "contain" }} width={85} />
            </div>,
            <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
              <img alt="BrandLock" height={35} src={brandLockLogo} style={{ objectFit: "contain" }} width={90} />
            </div>,
            <div style={{ alignItems: "center", display: "flex", justifyContent: "center" }}>
              <img alt="Promo Pirates" height={35} src={promoPiratesLogo} style={{ objectFit: "contain" }} width={90} />
            </div>,
          ]}
          rows={rows}
        />
      </ResourceListCard>
    </Page>
  );
};
